import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const RiskData = () => {
    
    const sections = [
        { label: "Risk Status", value: "RiskStatus", items: [] },
        { label: "Mitigation Action Status", value: "MitigationActionStatus", items: [] },
        { label: "Entity Person Responsible", value: "EntityPersonResponsible", items: [] },
        { label: "Category", value: "Category", items: [] },
        { label: "Impact Category", value: "ImpactCategory", items: [] },
        { label: "Severity", value: "Severity", items: [] },
    ];

    return (
        <MasterData pageTitle="Risk" sections={sections} />
    );
};

export default RiskData;